export function isSonnerInteractionTarget(target: EventTarget | null) {
  if (!(target instanceof Element)) {
    return false
  }

  return (
    target.closest('[data-sonner-toaster]') !== null ||
    target.closest('[data-sonner-toast]') !== null
  )
}
